<div>
  <div class="grid-container">
    <div class="grid-row">
      <div class="description fw-bold">Montant retenu (net vendeur)</div>
    </div>
  </div>

  <div class="grid-container text-primary ms-5">
    <div class="grid-row fw-bold">
      <div class="description">Estimation</div>
      <div class="value">
        {{
          appraisal.basicInfo.chosenValue
            | currency: "EUR" : "symbol" : "1.0-0" : "fr-FR"
        }}
      </div>
    </div>
  </div>

  <div class="grid-container ms-5">
    <div class="grid-row">
      <div class="description">Estimation Basse</div>
      <div
        *ngIf="appraisal.basicInfo.chosenLowValue; else noLowValue"
        class="value"
      >
        {{
          appraisal.basicInfo.chosenLowValue
            | currency: "EUR" : "symbol" : "1.0-0" : "fr-FR"
        }}
      </div>
      <ng-template #noLowValue>
        <p class="m-0 value">-</p>
      </ng-template>
    </div>
  </div>

  <div class="grid-container ms-5">
    <div class="grid-row">
      <div class="description">Estimation Haute</div>
      <div
        *ngIf="appraisal.basicInfo.chosenHighValue; else noHighValue"
        class="value"
      >
        {{
          appraisal.basicInfo.chosenHighValue
            | currency: "EUR" : "symbol" : "1.0-0" : "fr-FR"
        }}
      </div>
      <ng-template #noHighValue>
        <p class="m-0 value">-</p>
      </ng-template>
    </div>
  </div>
</div>
